<template>
<div :class="{clickable: !opened}" @click="!opened ? toggleView() : null">
  <base-card :key="healthVarsKey" :style="{'background-color': color, 'border-color': color}" :overflowVisible="overflowVisible" class="mb-4 history-wrapper-card" :title="title" :hideTitle="hideTitle" flowRoot :marginBottom="opened ? 3 : 0">
    <template v-if="!hideButtons & !showBtnLeft" #right-button>
        <base-button v-if="openBtnVisible">{{btnTitle}}</base-button><base-button :class="{'ml-2': openBtnVisible}" white v-if="accessBtnUrl || sectionPath" @click.stop="sectionPath ? goToSection(sectionPath) : accessBtnAction(accessBtnUrl)">{{$t('login-wrd')}}</base-button>
    </template>
    <div class="left-btn mt-3" v-if="!hideButtons && showBtnLeft">
        <base-button v-if="openBtnVisible">{{btnTitle}}</base-button><base-button :class="{'ml-2': openBtnVisible}" white v-if="accessBtnUrl || sectionPath" @click.stop="sectionPath ? goToSection(sectionPath) : accessBtnAction(accessBtnUrl)">{{$t('login-wrd')}}</base-button>
    </div>
    <button v-if="!hideButtons && opened" class="close close-btn-history-wrapper" @click.stop="closeCard">×</button>
    <slot v-if="opened"></slot>
  </base-card>
</div>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard.vue'
import BaseButton from '@/components/base/buttons/BaseButton'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        BaseCard,
        BaseButton
    },
    props: {
        title: String,
        hideTitleOnOpen: Boolean,
        overflowVisible: Boolean,
        defaultOpened: Boolean,
        hideButtons: Boolean,
        accessBtnUrl: String,
        healthVarsKey: String,
        sideBarTrigger: Number,
        hideViewBtn: Boolean,
        sectionPath: String,
        color: String,
        sameTab: Boolean
    },
    created () {
        if (this.defaultOpened) {
            this.opened = true
        }
    },
    data () {
        return {
            opened: false
        }
    },
    mixins: [clinicHistoryMixin],
    methods: {
        toggleView () {
            if (this.hideViewBtn && (this.accessBtnUrl || this.sectionPath)) {
                this.sectionPath ? this.goToSection(this.sectionPath) : this.accessBtnAction(this.accessBtnUrl)
            } else {
                this.opened = !this.opened
            }
        },
        accessBtnAction (route) {
            if (this.sameTab) {
                this.$router.push(route)
            } else {
                window.open(route, '_blank')
            }
        },
        closeCard () {
            this.opened = false
        }
    },
    computed: {
        hideTitle () {
            return !this.title || (this.hideTitleOnOpen && this.opened)
        },
        btnTitle () {
            return !this.opened ? this.$t('watch') : this.$t('close')
        },
        showBtnLeft () {
            return this.$uiHelpers.isMobile || this.$uiHelpers.isTablet
        },
        openBtnVisible () {
            return !this.opened && !this.hideViewBtn
        }
    },
    watch: {
        sideBarTrigger (newValue, OldValue) {
            this.opened = true
        }
    }
}
</script>

<style lang="scss" scoped>
.left-btn{
    text-align: left;
}
@include media(mobile) {
    .btn{
        padding: .7rem 1.8rem;
    }
}
.close-btn-history-wrapper{
    position: absolute;
    right: 2rem;
    top: 1rem;
    @include media(mobile) {
        right: 1rem;
        top: 0.4rem;
    }
}
@include media (mobile) {
    .history-wrapper-card{
        /deep/ h3{
            font-size: 1.27rem;
        }
    }
}
/deep/ .history-wrapper-card .neu-card-title {
    text-align: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/ClinicHistorySectionWrapper.vue